import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from '@material-ui/core/Button';
import {
  PaginationComponent,
  ViewTypes,
  Spinner,
  NoContentComponent,
} from "../../../../../Components";
import { bottomBoxComponentUpdate, GetParams } from "../../../../../Helper";
import { ViewTypesEnum, UnitsOperationTypeEnum  } from "../../../../../Enums";
import { ActiveInquiryViewsEnum } from "../../../LeadsSalesView/LeadsSalesProfileManagementView/Sections/LeadInquiriesView/ActiveInquiryViewsEnum";
import {
  leadDetailsGet,
  GetNearAndExactMatchUnitsAPI,
} from "../../../../../Services";
import { LeadMatchingUnitsCards } from "../../LeadsUtilities";
import ProposalStartButton from "../../../SmartProposal/Utilities/ProposalThemeDialog/ProposalStartButton";
import useSmartProposalActions from "../../../SmartProposal/Hooks/useProposalStart";
import { UnitMapper } from "../../../UnitsSalesView/UnitMapper/UnitMapper";

export const LeadMatchingUnitsComponent = ({
  parentTranslationPath,
  translationPath,
  activeItem
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [activeUnit, setActiveUnit] = useState(null);
  const [leadData, setLeadData] = useState(null);
  const [activeView, setActiveView] = useState(
    ActiveInquiryViewsEnum.MatchedUnit
  );

  const [filter, setFilter] = useState({
    pageSize: parseInt(localStorage.getItem("Pagination")) || 25,
    pageIndex: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [leadClass, setLeadClass] = useState(null);
  const [leadFilter, setLeadFilter] = useState({
    propertyId: null,
    operationTypeId: null,
    unitTypeIds: null,
    bedrooms: null,
    budget: null,
  });
  const [unitData, setUnitData] = useState({
    result: [],
    totalCount: 0,
  });

  const [isSmartProposalActive, setIsSmartProposalActive] = useState(false);
  const [activeLead, setActiveLead] = useState(null);
  const [sendProposalAll, setSendProposalAll] = useState(false);
  const [checkedCards, setCheckedCards] = useState([]);
  const [checkedDetailedCards, setCheckedDetailedCards] = useState([]);
  const [allUnits, setAllUnits] = useState({
    result: [],
    totalCount: 0,
  });

  function convertObject1ToObject2(obj1) {
  const unit = obj1?.unit || {};

  const unitJsonObj = {
    unit: {
      selling_price_agency_fee: unit.selling_price_agency_fee || {
        salePrice: 0,
        agencyFee: 0,
        persantageFee: 0
      },
      unit_type_id: unit.unit_type_id || null,
      operation_type: unit.operation_type || null,
      new_unit: "No",
      unit_type: unit.unit_type || null,
      furnished: "N/A",
      property_name: unit.property_name || null,
      unit_number: "N/A",
      data_completed: unit.data_completed || 0,
      sale_type: unit.sale_type || null,
      unit_ref_no: unit.unit_ref_no || null,
      status: unit.status || null,
      unit_usage_type: unit.unit_usage_type || null,
      owner: unit.owner || [],
      amount_due_to_developer: unit.amount_due_to_developer || 0,
      discount: 0,
      transfer_fee_seller: 0,
      transfer_fee_buyer: 0,
      transfer_fee_completed_paid: 0,
      seller_has_paid: 0,
      builtup_area_sqft: unit.builtup_area_sqft || 0,
      bedrooms: unit.bedrooms || 0,
      bathrooms: "—",
      community: unit.community || null,
      sub_community: null,
      country: unit.country || null,
      city: unit.city || null,
      district: unit.district || null
    }
  };

  return {
    unitId: obj1.unitId,
    unitJson: JSON.stringify(unitJsonObj),
    createdOn: obj1.createdOn,
    updateOn: obj1.updateOn,
    status: obj1.status,
    leaseStatus: obj1.leaseStatus,
    matchUnit: obj1.matchUnit || null,
    createdBy: obj1.createdBy,
    updatedBy: obj1.updatedBy,
    portalsJson: null,
    isPublishUnitSale: obj1.isPublishUnitSale || null,
    isPublishUnitLease: obj1.isPublishUnitLease || null,
    statusDate: obj1.statusDate || null,
    lastSalePublishDate: obj1.lastSalePublishDate || null,
    lastLeasePublishDate: obj1.lastLeasePublishDate || null,
    statusCreatedByName: obj1.statusCreatedByName || null,
    updatedOwnerDate: obj1.updatedOwnerDate || null,
    isSharedUnit: obj1.isSharedUnit || null,
    unitImages: obj1.unitImages || null,
    isBulkUpload: obj1.isBulkUpload || null,
    totalCount: obj1.totalCount || 0,
    lastActivityTypeId: obj1.lastActivityTypeId || 0,
    lastActivtyTypeName: obj1.lastActivtyTypeName || null,
    lastActivityDate: obj1.lastActivityDate || null,
    isFavorite: obj1.isFavorite || false,
    isDealOfTheDay: obj1.isDealOfTheDay || null,
    dealExpirationPeriod: obj1.dealExpirationPeriod || null,
    dealStartDate: obj1.dealStartDate || null,
    marketComparison: obj1.marketComparison || "",
    favoriteFolderId: obj1.favoriteFolderId || null,
    masterDeveloper: obj1.masterDeveloper || null,
    matchType: obj1.matchType || null,
    listUnitImages: obj1.listUnitImages || null,
    numberOfParkingSpaces: obj1.numberOfParkingSpaces || 0,
    propertyUnitDistrict: obj1.propertyUnitDistrict || null,
    propertyUnitCity: obj1.propertyUnitCity || null,
    propertyUnitCommunity: obj1.propertyUnitCommunity || null,
    propertyUnitCountry: obj1.propertyUnitCountry || null,

    // Flattened fields
    selling_price_agency_fee: unit?.selling_price_agency_fee?.salePrice || 0,
    unit_type_id: unit.unit_type_id,
    operation_type: unit.operation_type,
    new_unit: "No",
    unit_type: unit.unit_type,
    furnished: "N/A",
    property_name: unit.property_name,
    unit_number: "N/A",
    data_completed: unit.data_completed,
    sale_type: unit.sale_type,
    unit_ref_no: unit.unit_ref_no,
    unit_usage_type: unit.unit_usage_type,
    owner: unit.owner?.map(o => o.name),
    amount_due_to_developer: unit.amount_due_to_developer,
    discount: 0,
    transfer_fee_seller: 0,
    transfer_fee_buyer: 0,
    transfer_fee_completed_paid: 0,
    seller_has_paid: 0,
    builtup_area_sqft: unit.builtup_area_sqft,
    bedrooms: unit.bedrooms,
    bathrooms: "N/A",
    community: unit.community,
    sub_community: null,
    country: unit.country,
    city: unit.city,
    district: unit.district,

    // Additional example properties (can be added if needed)
    publishing_requestor: "N/A",
    publishing_requester: "",
    allunitImages: null,
    portals: null,
    refNo: unit.unit_ref_no || null,
    id: obj1.unitId,
    type: "corporate",
    name: `${unit.unit_type?.lookupItemName || 'Unit'} ${unit.property_name?.name || ''} ${unit.unit_number || ''}`.trim(),
    propertyName: unit.property_name?.name || '',
    updateDate: obj1.updateOn,
    matchingLeads: [],
    matchingLeadsNumber: 0,
    unitTypeId: unit.unit_type_id,
    unitType: unit.unit_type?.lookupItemName || '',
    progress: unit.data_completed || 0,
    progressWithPercentage: `${unit.data_completed || 0}%`,
    operationType: unit.operation_type?.lookupItemId,
    unitOperationType: unit.operation_type?.lookupItemName,
    unitStatus: {
      key: obj1.status,
      value: unit.status?.toLowerCase() || "available",
      name: unit.status || "Available",
      showInSelect: true,
      effectedOperationType: unit.operation_type?.lookupItemId || null,
      classes: "c-primary",
      category: {
        key: 21426,
        value: "sale-sold"
      },
      display: unit.status || "Available"
    },
    rent_price_fees: "N/A"
  };
}

  useSmartProposalActions({
    proposalUnits: checkedDetailedCards ? checkedDetailedCards.map((unitData)=> {
    
       return unitData && convertObject1ToObject2(unitData);
    }) :   [],
    proposalLeads: activeLead
      ? [
          {
            leadId: GetParams('id'),
            lead: activeLead,
            contactEmailAddress: activeLead?.contact_name?.email_address,
            contactPhoneNumber:
              activeLead?.contact_name?.mobile ||
              activeLead?.contact_name?.phone,
            contactWhatsApp:
              activeLead?.contact_name?.mobile ||
             activeLead?.contact_name?.phone,
          },
        ]
      : null,
  });

  const GetNearAndExactMatchUnits = useCallback(async () => {
    setIsLoading(true);
    const result = await GetNearAndExactMatchUnitsAPI(
      filter.pageIndex + 1,
      filter.pageSize,
      leadFilter
    );

    if (!(result && result.status && result.status !== 200)) {
      setUnitData({
        result: result.result,
        totalCount: result.totalCount,
      });
    } else {
      setUnitData({
        result: [],
        totalCount: 0,
      });
    }

    setIsLoading(false);
  }, [filter, leadClass, leadFilter]);

  const GetLeadClass = useCallback(async () => {
    const leadId = +GetParams("id");
    const result = await leadDetailsGet({ id: leadId });
    if (!(result && result.status && result.status !== 200)) {
      const leadInfo = result?.lead;
      setActiveLead(leadInfo);
      setLeadClass(leadInfo?.leadClass);
      setLeadFilter({
        propertyId: leadInfo?.property_name?.id || null,
        operationTypeId: leadInfo?.leadClass
          ? leadInfo.leadClass === "Buyer"
            ? UnitsOperationTypeEnum.sale.key
            : UnitsOperationTypeEnum.rent.key
          : null,
        unitTypeIds:
          leadInfo?.propertyunit_type &&
          leadInfo.propertyunit_type.map((el) => el.lookupItemId),
        bedrooms: leadInfo?.bedrooms
          ? leadInfo.bedrooms[0] && leadInfo?.bedrooms[0] === "Any"
            ? []
            : leadInfo?.bedrooms
          : [],
        budget: leadInfo?.budgetTo || null,
      });
      localStorage.setItem(
        "leadDetails",
        JSON.stringify(result && result.lead)
      );
    } else {
      setLeadClass(null);
      setActiveLead(null);
      setLeadFilter({
        propertyId: null,
        operationTypeId: null,
        unitTypeIds: null,
        bedrooms: null,
        budget: null,
      });
    }
  }, []);

  useEffect(() => {
    if (leadClass && leadFilter?.operationTypeId) GetNearAndExactMatchUnits();
  }, [filter, leadClass, leadFilter]);

  useEffect(() => {
    GetLeadClass();
  }, [GetLeadClass]);

  useEffect(() => {
    if (unitData && unitData.result && leadClass) {
      const mapperList = unitData?.result.map((m) => {
        const unit = m.unitJson ? JSON.parse(m.unitJson) : null;
        m.newMatchingUnitIsSale = leadClass === "Buyer" ? true : false;

        const fullAddress =
          (m?.propertyUnitCity && `${m?.propertyUnitCity}`) +
          (m?.propertyUnitDistrict && ` , ${m?.propertyUnitDistrict}`) +
          (m?.propertyUnitCommunity && ` , ${m?.propertyUnitCommunity}`) ; 
        
        delete m.unitJson;
        return {
          ...m,
          ...unit,
          location:
            unit?.unit?.city &&
            `${
              (unit?.unit?.city?.lookupItemName -
                (unit?.unit?.district?.lookupItemName || ""),
              unit?.unit?.community?.lookupItemName || "")
            }`,
          listing_agent: m.newMatchingUnitIsSale
            ? unit?.unit?.listing_agent?.name ||
              unit?.unit?.sale_listing_agent?.name ||
              null
            : unit?.unit?.rent_listing_agent?.name || null,
          price: m.newMatchingUnitIsSale
            ? (unit?.unit?.selling_price_agency_fee?.salePrice &&
                +unit.unit.selling_price_agency_fee.salePrice) ||
              null
            : (unit?.unit?.rent_price_fees?.rentPerYear &&
                +unit.unit.rent_price_fees.rentPerYear) ||
              null,
          unitNewStatus: "Available",
          fullAddress,
        };
      });
      setAllUnits({
        result: mapperList || [],
        totalCount: unitData.totalCount,
      });
    } else {
      setAllUnits({
        result: [],
        totalCount: [],
      });
    }
  }, [unitData, leadClass]);

  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex }));
  };
  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));
  };
  const [activeActionType, setActiveActionType] = useState(
    ViewTypesEnum.cards.key
  );
  const onTypeChanged = useCallback(
    (activeType) => {
      setActiveActionType(activeType);
    },
    [setActiveActionType]
  );

  useEffect(() => {
    if (activeView !== ActiveInquiryViewsEnum.UnitOverview)
      bottomBoxComponentUpdate(
        <div className="bottom-box-two-sections">
          <PaginationComponent
            pageIndex={filter.pageIndex}
            pageSize={filter.pageSize}
            totalCount={unitData.totalCount}
            onPageIndexChanged={onPageIndexChanged}
            onPageSizeChanged={onPageSizeChanged}
          />
        </div>
      );
    else bottomBoxComponentUpdate(null);
  }, [unitData, filter, activeView]);

  const getIsSelectedCard = useCallback(
    (itemIndex) =>
      checkedDetailedCards.findIndex((item) => item?.unitId === itemIndex) !==
      -1,
    [checkedDetailedCards]
  );

  const cardCheckboxClicked = useCallback((itemIndex, element) => {
    setCheckedDetailedCards((items) => {
      const index = items.findIndex((item) => item.unitId === element?.unitId);
      if (index !== -1) items.splice(index, 1);
      else items.push(element);
      return [...items];
    });
    setCheckedCards((items) => {
      const index = items.findIndex((item) => item === element.unitId);
      if (index !== -1) items.splice(index, 1);
      else items.push(element.unitId);
      return [...items];
    });
  }, []);

  useEffect(
    () => () => {
      bottomBoxComponentUpdate(null);
    },
    []
  );
  

  return (
    <div className="lead-profile-units-wrapper px-0 pt-0 childs-wrapper">
      <div className="lead-profile-filter-section">
        <div className="filter-section-item px-0">
          <Spinner isActive={isLoading} isAbsolute />
          {allUnits.result?.length > 0 &&
            activeView === ActiveInquiryViewsEnum.MatchedUnit && (
              <div className="px-3 mt-2 mb-2">
                {activeLead && activeLead?.contact_name?.email_address ? (
                  <ProposalStartButton
                    checkboxSelectHandler={(isActive) => {
                      setIsSmartProposalActive(isActive);
                      if (!isActive) {
                        setCheckedDetailedCards([]);
                        setCheckedCards([]);
                      }
                    }}
                    buttonType={
                      isSmartProposalActive
                        ? "select-counter"
                        : "select-outline"
                    }
                    isLeadMatching={true}
                    fromLeadForm
                  />
                ) : (
                  <Button
                    onClick={() => {}}
                    disabled
                    className="btns theme-solid px-3"
                    title={t(
                      `${translationPath}this-lead-havent-email-address-to-send-smart-proposal`
                    )}
                  >
                    <span className="mdi mdi-rocket px-1" />
                    <span>{t(`${translationPath}smart-proposal`)}</span>
                  </Button>
                )}
              </div>
            )}

          <div></div>
          <div>
            <ViewTypes
              onTypeChanged={onTypeChanged}
              activeTypes={[
                // ViewTypesEnum.tableView.key,
                ViewTypesEnum.cards.key,
              ]}
              className="mb-3"
            />
          </div>
        </div>
      </div>
      {allUnits &&
        allUnits.result &&
        activeActionType === ViewTypesEnum.cards.key && (
          <div>
            {allUnits?.result && allUnits.result?.length > 0 && (
              <LeadMatchingUnitsCards
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                data={allUnits}
                totalCount={allUnits.totalCount}
                saleMatching={leadClass === "Buyer" ? true : false}
                activeUnit={activeUnit}
                setActiveUnit={setActiveUnit}
                activeView={activeView}
                setActiveView={setActiveView}
                activeLead={activeLead}
                isSmartProposalActive={isSmartProposalActive}
                setCheckedDetailedCards={setCheckedDetailedCards}
                getIsSelectedCard={(itemIndex) => getIsSelectedCard(itemIndex)}
                setCheckedCards={setCheckedCards}
                onCardCheckboxClick={(itemIndex, element) =>
                  cardCheckboxClicked(itemIndex, element)
                }
              />
            )}
            {allUnits.totalCount === 0 && <NoContentComponent />}
          </div>
        )}
    </div>
  );
};
